import React from "react";

export const PeopleIcon = () => {
  return (
    <svg
      width="61"
      height="62"
      viewBox="0 0 61 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_496_1353)">
        <path
          d="M30.4077 57.6669C44.9124 57.6669 56.6708 45.9085 56.6708 31.4038C56.6708 16.899 44.9124 5.14062 30.4077 5.14062C15.9029 5.14062 4.14453 16.899 4.14453 31.4038C4.14453 45.9085 15.9029 57.6669 30.4077 57.6669Z"
          fill="white"
        />
        <path
          d="M30.4073 32.6545C35.9329 32.6545 40.4123 28.1751 40.4123 22.6495C40.4123 17.1239 35.9329 12.6445 30.4073 12.6445C24.8817 12.6445 20.4023 17.1239 20.4023 22.6495C20.4023 28.1751 24.8817 32.6545 30.4073 32.6545Z"
          fill="#E4E9FF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50.8208 49.3176C46.3561 52.8244 36.9226 58.072 30.8108 58.072C24.699 58.072 15.2656 52.8244 10.8008 49.3176C11.705 41.2223 22.3866 38.062 30.8108 38.062C39.235 38.062 49.9166 41.2223 50.8208 49.3176Z"
          fill="#E4E9FF"
        />
        <path
          d="M4.65612 37.9177C5.3464 37.9177 5.90599 37.3581 5.90599 36.6678C5.90599 35.9776 5.3464 35.418 4.65612 35.418C3.96584 35.418 3.40625 35.9776 3.40625 36.6678C3.40625 37.3581 3.96584 37.9177 4.65612 37.9177Z"
          fill="#3C51A0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.1037 48.7021C7.25652 46.3334 5.78951 43.6559 4.79277 40.7594C4.56765 40.1066 4.91532 39.395 5.56815 39.1699C6.21972 38.946 6.93257 39.2924 7.15769 39.9452C7.89681 42.0938 8.92112 44.1098 10.1843 45.9482C15.2518 40.3417 22.6005 36.8112 30.8146 36.8112C39.0286 36.8112 46.3773 40.3417 51.4449 45.9482C54.2087 41.925 55.827 37.0551 55.827 31.8087C55.827 27.5978 54.784 23.6283 52.9431 20.1453C52.6204 19.535 52.8544 18.7772 53.4647 18.4545C54.075 18.1331 54.8316 18.3657 55.1542 18.976C57.1802 22.8079 58.3283 27.1751 58.3283 31.8087C58.3283 38.1769 56.1609 44.0423 52.5229 48.7059C52.5103 48.7234 52.4967 48.7409 52.4828 48.7572C47.4454 55.1879 39.609 59.3224 30.8146 59.3224C22.0214 59.3224 14.1876 55.1891 9.14873 48.7609C9.13372 48.7421 9.11745 48.7221 9.1037 48.7021ZM49.8966 47.973C45.2781 42.6704 38.4584 39.3124 30.8146 39.3124C23.1707 39.3124 16.3511 42.6704 11.7325 47.973C16.3223 53.3845 23.1707 56.8212 30.8146 56.8212C38.4584 56.8212 45.3068 53.3845 49.8966 47.973ZM5.82951 33.0005C5.86202 33.6896 5.3293 34.2762 4.63896 34.3087C3.94986 34.3412 3.36334 33.8072 3.33207 33.1181C3.31081 32.6841 3.30078 32.2477 3.30078 31.8087C3.30078 16.6236 15.6295 4.29492 30.8146 4.29492C39.9678 4.29492 48.0845 8.77467 53.087 15.6594C53.4922 16.2184 53.3684 17.0013 52.8106 17.4065C52.2516 17.8117 51.4686 17.6879 51.0634 17.1301C46.5149 10.8695 39.1375 6.79617 30.8146 6.79617C17.0101 6.79617 5.80203 18.0043 5.80203 31.8087C5.80203 32.2076 5.812 32.6053 5.82951 33.0005ZM30.8146 11.7987C37.0264 11.7987 42.0702 16.8425 42.0702 23.0543C42.0702 29.2662 37.0264 34.3099 30.8146 34.3099C24.6026 34.3099 19.559 29.2662 19.559 23.0543C19.559 16.8425 24.6026 11.7987 30.8146 11.7987ZM30.8146 14.2999C25.9834 14.2999 22.0602 18.2231 22.0602 23.0543C22.0602 27.8855 25.9834 31.8087 30.8146 31.8087C35.6456 31.8087 39.569 27.8855 39.569 23.0543C39.569 18.2231 35.6456 14.2999 30.8146 14.2999Z"
          fill="#3C51A0"
        />
      </g>
      <defs>
        <clipPath id="clip0_496_1353">
          <rect
            width="60"
            height="61"
            fill="white"
            transform="translate(0.4375 0.758789)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
